var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mm-page mm-slideout",attrs:{"id":"wrapper"}},[_c('TheHeader'),_vm._v(" "),_c('div',{staticClass:"clearfix"}),_vm._v(" "),_c('div',{staticClass:"dashboard-container"},[_c('TheSidebar'),_vm._v(" "),_c('ContentWrapper',[_c('nuxt')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }